"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../../general/Button"));

var _overrides = require("../../../utils/overrides");

var _MultiplierControl = _interopRequireDefault(require("./MultiplierControl"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Multiplier');

function Multiplier(_ref) {
  var _classnames, _classnames2;

  var classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      schema = _ref.schema,
      name = _ref.name,
      buttonLabel = _ref.buttonLabel,
      buttonClassName = _ref.buttonClassName,
      isFullWidth = _ref.isFullWidth,
      isReadOnly = _ref.isReadOnly,
      max = _ref.max,
      separator = _ref.separator,
      value = _ref.value,
      error = _ref.error,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      labelMode = _ref.labelMode,
      customFields = _ref.customFields,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "overrides", "className", "schema", "name", "buttonLabel", "buttonClassName", "isFullWidth", "isReadOnly", "max", "separator", "value", "error", "onChange", "onFocus", "onBlur", "labelMode", "customFields"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // State

  var size = value.length; // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Multiplier.overrides); // Classes

  var rootClassName = (0, _classnames3.default)(classes.root, classNameProp, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes.vertical, labelMode === 'vertical'), _classnames));
  var buttonClassNames = (0, _classnames3.default)(classes.button, buttonClassName);
  var multiplierItemClassNames = (0, _classnames3.default)(classes.item, (_classnames2 = {}, (0, _defineProperty2.default)(_classnames2, classes.separator, separator), (0, _defineProperty2.default)(_classnames2, classes.singleItem, !Array.isArray(schema)), _classnames2));
  var rootProps = (0, _extends2.default)({
    className: rootClassName
  }, override.root);
  var onClickAdd = (0, _react.useCallback)(function () {
    var newValues = (0, _toConsumableArray2.default)(value);
    newValues.push(null);
    onChange && onChange(newValues, null);
  }, [onChange, value]);
  var onClickRemove = (0, _react.useCallback)(function (schema, index) {
    var newValues = [].concat((0, _toConsumableArray2.default)(value.slice(0, index)), (0, _toConsumableArray2.default)(value.slice(index + 1)));
    onChange && onChange(newValues, value[index], index, schema);
  }, [onChange, value]);
  var onChangeMultiplier = (0, _react.useCallback)(function (newValue, schema, index) {
    var newValues = (0, _toConsumableArray2.default)(value);
    newValues[index] = newValue;
    onChange && onChange(newValues, newValue, index, schema);
  }, [onChange, value]);
  var type = Array.isArray(schema) ? 'form' : 'field';
  var items = [];

  for (var index = 0; index < value.length; index++) {
    items.push( /*#__PURE__*/_react.default.createElement(_MultiplierControl.default, (0, _extends2.default)({
      key: index,
      index: index,
      type: type,
      schema: schema,
      labelMode: schema.labelMode || labelMode,
      isFullWidth: schema.isFullWidth || isFullWidth,
      isReadOnly: isReadOnly || schema.isReadOnly,
      values: value[index],
      errors: error[index],
      onChange: onChangeMultiplier,
      onFocus: onFocus,
      onBlur: onBlur,
      onRemove: size > 1 ? onClickRemove : undefined,
      className: multiplierItemClassNames,
      customFields: customFields
    }, override.multiplierControl, {
      overrides: override,
      removeIconClassName: classes.removeIcon
    })));
  }

  var showButton = !(max && size >= max) && isReadOnly !== true;
  return /*#__PURE__*/_react.default.createElement("div", rootProps, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.container
  }, override.container), items), showButton && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.buttonContainer
  }, override.buttonContainer), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    type: "squared-outlined",
    className: buttonClassNames,
    onClick: onClickAdd
  }, override.button, {
    overrides: override.button
  }), buttonLabel)));
}

Multiplier.overrides = ['root', 'multiplierControl', 'button'];
Multiplier.defaultProps = {
  error: {},
  value: [null],
  fields: [],
  separator: false,
  labelMode: 'horizontal',
  isFullWidth: false
};
process.env.NODE_ENV !== "production" ? Multiplier.propTypes = {
  /** Native form class */
  schema: _propTypes.default.any,
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  labelMode: _propTypes.default.string,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  buttonLabel: _propTypes.default.string,
  buttonClassName: _propTypes.default.string,
  fields: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    labelMode: _propTypes.default.string,
    isFullWidth: _propTypes.default.bool,
    name: _propTypes.default.string,
    type: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    hint: _propTypes.default.string,
    isRequired: _propTypes.default.bool,
    isReadOnly: _propTypes.default.bool,
    attrs: _propTypes.default.object,
    className: _propTypes.default.string
  })),
  max: _propTypes.default.number,
  separator: _propTypes.default.bool,
  remove: _propTypes.default.bool,
  value: _propTypes.default.array,
  error: _propTypes.default.any,
  isFullWidth: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  customFields: _propTypes.default.object
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Multiplier);

exports.default = _default;